//react
import React from 'react';

//redux
import { connect } from 'react-redux';

//firebase
import { db } from 'assets/firebase';

//styles
import withStyles from "@material-ui/core/styles/withStyles";
import modalStyle from "assets/jss/material-kit-react/modalStyle.jsx";

//core
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";

//components
import CustomTabs from "components/CustomTabs/CustomTabs.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";

// @material-ui/icons
import Settings from "@material-ui/icons/SettingsRounded";

//google Analytics
import ReactGA from 'react-ga';
ReactGA.initialize('UA-127392840-1');

function Transition(props) {
    return <Slide direction="down" {...props} />;
  }
  
  class SettingsEditor extends React.Component {
    constructor(props) {
      super(props);

      this.state = {
        modal: false,
        settings: { id: "default", q1Enabled: false, q2Enabled: false, q3Enabled: false, q4Enabled: false}
      };

      this.getSettings = this.getSettings.bind(this);
      this.saveSettings = this.saveSettings.bind(this);
      this.updateSettings = this.updateSettings.bind(this);
    }

    handleClickOpen(modal) {
      this.getSettings();

      var x = [];
      x[modal] = true;
      this.setState(x);
    }

    handleClose(modal) {
      var x = [];
      x[modal] = false;
      this.setState(x);
    }

    getSettings() {
        db.getSettings('default').then(settings => {
            this.setState({settings: settings});
        });
    }

    updateSettings(property, value) {
      var obj = this.state.settings;
      obj[property] = value;
      this.setState({settings: obj});
    }

    saveSettings() {
    
      db.updateSettings(this.state.settings.id, this.state.settings).then(doc => {
        
        ReactGA.event({
            category: 'Settings',
            action: 'Updated Settings'
        });
        
      });
    }
        
    render() {

      const { classes } = this.props;

      return (
        <div>
          
          <IconButton
            aria-label="Settings"
            onClick={() => this.handleClickOpen("modal")}>
            <Settings className={classes.tableActionButtonIcon + " " + classes.edit} style={{color:"#343434"}} />
          </IconButton>
          <Dialog
            classes={{
              root: classes.center,
              paper: classes.modal
            }}
            open={this.state.modal}
            TransitionComponent={Transition}
            keepMounted
            onClose={() => this.handleClose("modal")}
            aria-labelledby="modal-slide-title"
            aria-describedby="modal-slide-description">

            <DialogTitle
              id="classic-modal-slide-title"
              disableTypography
              className={classes.modalHeader}
              style={{backgroundColor:"#efefef"}} >

              <GridContainer direction="row">
                <GridItem xs={12} sm={12} md={6}>
                  <h4 className={classes.modalTitle}>Edit Settings</h4>
                </GridItem>
                <GridItem xs={12} sm={12} md={6} style={{textAlign:"right"}}>
                  
                </GridItem>
              </GridContainer>
            </DialogTitle>
            <DialogContent
              id="modal-slide-description"
              className={classes.modalBody}
              style={{backgroundColor:"#efefef"}}>
             <CustomTabs
                headerColor="success"
                tabs={[
                  {
                    tabName: "General",
                    tabIcon: Settings,
                    tabContent: (
                      
                        <GridContainer direction="row">
                            <GridItem xs={12} sm={12} md={6}>
                                <GridContainer direction="row">
                                    <GridItem xs={12} sm={12} >
                                        <div style={{color:"green", marginTop:"17px"}}>
                                            Publishing
                                        </div>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} >
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={this.state.settings.q1Enabled}
                                                    onChange={(e) => this.updateSettings("q1Enabled", e.target.checked)}
                                                    classes={{
                                                    switchBase: classes.switchBase,
                                                    checked: classes.switchChecked,
                                                    icon: classes.switchIcon,
                                                    iconChecked: classes.switchIconChecked,
                                                    bar: classes.switchBar
                                                    }}
                                                />
                                            }
                                            classes={{
                                                label: classes.label
                                            }}
                                            label="Enable Q1"
                                        />
                                    </GridItem>
                                    <GridItem xs={12} sm={12} >
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={this.state.settings.q2Enabled}
                                                    onChange={(e) => this.updateSettings("q2Enabled", e.target.checked)}
                                                    classes={{
                                                    switchBase: classes.switchBase,
                                                    checked: classes.switchChecked,
                                                    icon: classes.switchIcon,
                                                    iconChecked: classes.switchIconChecked,
                                                    bar: classes.switchBar
                                                    }}
                                                />
                                            }
                                            classes={{
                                                label: classes.label
                                            }}
                                            label="Enable Q2"
                                        />
                                    </GridItem>
                                    <GridItem xs={12} sm={12} >
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={this.state.settings.q3Enabled}
                                                    onChange={(e) => this.updateSettings("q3Enabled", e.target.checked)}
                                                    classes={{
                                                    switchBase: classes.switchBase,
                                                    checked: classes.switchChecked,
                                                    icon: classes.switchIcon,
                                                    iconChecked: classes.switchIconChecked,
                                                    bar: classes.switchBar
                                                    }}
                                                />
                                            }
                                            classes={{
                                                label: classes.label
                                            }}
                                            label="Enable Q3"
                                        />
                                    </GridItem>
                                    <GridItem xs={12} sm={12} >
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={this.state.settings.q4Enabled}
                                                    onChange={(e) => this.updateSettings("q4Enabled", e.target.checked)}
                                                    classes={{
                                                    switchBase: classes.switchBase,
                                                    checked: classes.switchChecked,
                                                    icon: classes.switchIcon,
                                                    iconChecked: classes.switchIconChecked,
                                                    bar: classes.switchBar
                                                    }}
                                                />
                                            }
                                            classes={{
                                                label: classes.label
                                            }}
                                            label="Enable Q4"
                                        />
                                    </GridItem>
                                </GridContainer>
                            </GridItem>
                        </GridContainer>
                    )
                  }
                ]}
              />

            </DialogContent>
            
            <DialogActions
              className={classes.modalFooter }
              style={{backgroundColor:"#efefef"}}>
              <Button
                    onClick={() => this.handleClose("modal")}
                  >
                    Cancel
                  </Button>
                  &nbsp;
                  <Button
                    onClick={() => {
                       this.saveSettings();
                        this.handleClose("modal");
                      }}
                    color="success">
                    Save
                  </Button>
            </DialogActions>
          </Dialog>
        </div>
      );
    }
  }
  
const mapStateToProps = state => {
  return state;
}

SettingsEditor = connect(mapStateToProps)(SettingsEditor);
export default withStyles(modalStyle)(SettingsEditor);


// WEBPACK FOOTER //
// ./src/components/SettingsEditor/SettingsEditor.jsx